<!-- Modal for manipulating sections and subsections in project table -->
<script lang="ts">
    import { getModalStore, type ModalStore } from "@skeletonlabs/skeleton";

    import BlackX from "$lib/assets/BlackX.svg";

    const modalStore: ModalStore = getModalStore();

    // Flag variable for checking if a subsection or a section is being edited
    let type: "Section" | "Subsection" | "Questions" = $modalStore[0].meta.type;

    // Flag variable for checking the type of action the modal is to serve
    let action: "Add" | "Delete" | "Rename" = $modalStore[0].meta.action;

    let name: string = "";

    function do_submit(e: Event) {
        e.preventDefault();
        $modalStore[0].response!({ name: name });
        modalStore.clear();
    }
</script>

<div class="bg-white rounded-lg p-8">
    <div class="flex items-center">
        <p class="font-bold">{action} {type}</p>
        <button
            class="ml-auto rounded-full hover:bg-stone-100 transition duration-300 p-1"
            on:click={() => modalStore.clear()}
        >
            <img src={BlackX} alt="Exit" />
        </button>
    </div>

    <form on:submit={do_submit}>
        {#if action != "Delete"}
            <label for="name" class="text-sm mt-8">{type == "Questions" ? "Number of Questions" : type + " Name"}</label
            >
            {#if type == "Questions"}
                <input
                    id="name"
                    type="number"
                    class="rounded-full w-80 text-sm"
                    placeholder="Number"
                    bind:value={name}
                />
            {:else}
                <input id="name" type="text" class="rounded-full w-80 text-sm" placeholder="Name" bind:value={name} />
            {/if}
        {:else}
            <p class="w-80 mt-8">
                {#if type == "Questions"}
                    Are you sure you want to delete the selected question(s)? All information inside will be permanently
                    deleted.
                {:else}
                    Are you sure you want to delete this section? All questions and information inside will be
                    permanently deleted.
                {/if}
            </p>
        {/if}
        <div class="flex mt-10">
            <button
                type="submit"
                class="rounded-full bg-zinc-800 px-4 py-2 text-white hover:shadow-md transition duration-300 text-sm"
            >
                {action == "Delete" ? "Delete" : "Save"}
            </button>
            <button
                type="button"
                class="rounded-full border border-black text-sm ml-3 px-4 py-2 hover:shadow-md transition duration-300"
                on:click={() => modalStore.clear()}
            >
                Cancel
            </button>
        </div>
    </form>
</div>
